module.exports = __webpack_public_path__ + "img/login.cb736e35.png";